import { Button } from 'blaze-ui/Button'
import { AnalysisErrorProps } from './Types'
import { WrapperCard } from 'components/AddCampaignModal/WrapperCard'
import { DragOverlay, Dropzone } from 'screens/Uploads/Dropzone/Dropzone'
import { Heading } from 'blaze-ui/Heading/Heading'
import { VideoHighDetail } from 'blaze-ui/icons/40'
import 'screens/BrandKits/components/SourceMaterialModal/validation/validationSchema'
import { useCallback, useMemo } from 'react'
import { validationSchema } from './validationSchema'
import Styles from './AnalysisError.module.scss'
import { AlertTriangle } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import {
  UPLOAD_AUDIO_MIME_TYPES,
  UPLOAD_DOCUMENT_MIME_TYPES,
  UPLOAD_VIDEO_MIME_TYPES,
} from 'screens/Finder/components/views/GalleryView/constants'
import { ModalSubmitContainer } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalSubmitContainer'

export const AnalysisError = ({ error, onNext, targetLink }: AnalysisErrorProps) => {
  const onUpload = useCallback(
    async (file: File) => {
      try {
        validationSchema.validateSync(file)

        onNext({
          file: file,
        })
      } catch (error) {
        if (error instanceof Error && error.name === 'ValidationError') {
          showErrorMessageToast(error.message)
        }
      }
    },
    [onNext],
  )

  const errorMessage = useMemo(() => {
    if (error?.name === 'YoutubeLinkError') {
      return "Per YouTube guidelines, we can't analyze your video link. Please provide the same video file for us to parse."
    }

    return 'There was an error processing the file. Please try again.'
  }, [error])

  return (
    <div className={Styles.wrapper}>
      <WrapperCard>
        <div className={Styles.header}>
          <div className={Styles.error}>
            <div className={Styles.errorIcon}>
              <AlertTriangle size={24} color="var(--light-100)" />
            </div>
            <Text variant="placeholder">{targetLink}</Text>
          </div>
          <Heading level={3}>{errorMessage}</Heading>
        </div>

        <div className={Styles.dropzoneWrapper}>
          <Dropzone
            onDrop={(files) => onUpload(files[0])}
            styles={Styles.dropzone}
            buttonText="Choose File"
            supportText="Blaze supports MP4, MPEG, AVI"
            buttonVariant="secondary"
            IconComponent={() => <VideoHighDetail size={50} />}
            DragOverlayComponent={DragOverlay}
            supportTextColor="var(--dark-60)"
            supportTextVariant="secondary"
            multiple={false}
            accept={[...UPLOAD_DOCUMENT_MIME_TYPES, ...UPLOAD_AUDIO_MIME_TYPES, ...UPLOAD_VIDEO_MIME_TYPES].join(',')}
          >
            <div className={Styles.dropzoneContent}>
              <Heading level={3}>Drop your file here</Heading>
            </div>
          </Dropzone>
        </div>
      </WrapperCard>
      <ModalSubmitContainer>
        <Button size="lg" isDisabled>
          Continue
        </Button>
      </ModalSubmitContainer>
    </div>
  )
}
